import { useState, useEffect } from 'react';
import { Form, Input, Popconfirm, Button, Card, Select, DatePicker, Space, Row, Col, Tabs, message, Modal, Switch, Tag, Divider } from 'antd'; // Import Tabs
import cookies from 'js-cookie';
import axiosConfig from '../../shared/utils/axios-config';
import { useSelector } from 'react-redux';
import { MinusCircleOutlined, PlusOutlined, UpOutlined, DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { withRouter, useHistory, Link, useParams } from 'react-router-dom';
import moment from "moment";
import './asap-details.scss';

const { Option } = Select;
const { TabPane } = Tabs; // Destructure TabPane from Tabs

const EditPropertyData = () => {

    const params = useParams();
    let history = useHistory();
    const [form] = Form.useForm();
    const [rejectForm] = Form.useForm();
    const [validatedForm] = Form.useForm();
    const [collapsedVendors, setCollapsedVendors] = useState({});
    const [purchasersCollapsed, setPurchasersCollapsed] = useState(false);
    const [sellingAgentCollapsed, setSellingAgentCollapsed] = useState(false);
    const [mortgageBrokerCollapsed, setMortgageBrokerCollapsed] = useState(false);
    const [propertyDetailsCollapsed, setPropertyDetailsCollapsed] = useState(false);
    const [chainInformationCollapsed, setChainInformationCollapsed] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [loadedKeys, setLoadedKeys] = useState(new Set());  // cache for loaded iframes

    const [activeKey, setActiveKey] = useState(
        documents?.length > 0 ? documents[0].key : null
    );
    const [initialData, setInitialData] = useState({});
    const [extractedData, setExtractedData] = useState({});
    const [moderatedData, setModeratedData] = useState({});
    const [loading, setLoading] = useState(true);
    const currentUser = useSelector((state) => state.auth.currentUser);

    const [visible, setVisible] = useState(false);
    const [validatedVisible, setValidatedVisible] = useState(false);

    const showModal = () => {
        setVisible(true);
    };

    const showValidatedModal = () => {
        setValidatedVisible(true);
    };

    const handleOk = async () => {
        rejectForm
            .validateFields()
            .then(async (values) => {
                console.log("Reject reason:", values.reason);
                let reason = values.reason;
                await handleReject(reason);
                setVisible(false);
                rejectForm.resetFields();
            })
            .catch((info) => {
                console.log("Validate Failed:", info);
            });
    };

    const handleCancel = () => {
        setVisible(false);
        rejectForm.resetFields();
    };

    const getValidateRequestFromFormValues = (values, comments = "") => {
        let payload = {
            ...values,
            validation: extractedData?.validation ?? "",
            property: {
                ...values.property,
                memo_date: values.property?.memo_date
                    ? values.property.memo_date.format("DD-MM-YYYY")
                    : null
            },
            count_Vendors: values.vendors?.length ?? 0,
            count_Purchasers: values.purchasers?.length ?? 0,
        };
        payload["Agent Branch"] = payload?.selling_agent?.person_branch ?? "";

        let validateCaseRequest = {};
        validateCaseRequest.ValidatedData = JSON.stringify(payload);
        validateCaseRequest.comments = comments;
        return validateCaseRequest;
    };

    const handleValidatedCancel = () => {
        setValidatedVisible(false);
        validatedForm.resetFields();
    };

    const handleValidatedSubmit = async () => {
        validatedForm
            .validateFields()
            .then((values) => {
                Modal.confirm({
                    title: "Confirm validation",
                    content: "Are you sure you want to validate this case?",
                    okText: "Confirm",
                    cancelText: "Cancel",
                    onOk: async () => {
                        const formValues = form.getFieldsValue();
                        const comments = values?.comments ?? "";
                        const validateCaseRequest = getValidateRequestFromFormValues(formValues, comments);
                        await validateCase(validateCaseRequest);
                        await setStatusCompleted(comments);
                        message.success("Case VALIDATED SUCCESSFULLY");
                        setValidatedVisible(false);
                        validatedForm.resetFields();
                    },
                });
            })
            .catch((info) => {
                console.log("Validate Failed:", info);
            });
    };

    const handleSubmit = async () => {

        const values = form.getFieldsValue();
        console.log("Form Values", values);

        let payload = {
            ...values,
            validation: extractedData?.validation ?? "",
            property: {
                ...values.property,
                memo_date: values.property?.memo_date
                    ? values.property.memo_date.format("DD-MM-YYYY")
                    : null
            },
            count_Vendors: values.vendors.length,
            count_Purchasers: values.purchasers.length,
        };
        payload["Agent Branch"] = payload?.selling_agent?.person_branch ?? "";

        let validateCaseRequest = {};
        validateCaseRequest.ValidatedData = JSON.stringify(payload);

        await axiosConfig({
            method: 'post',
            data: validateCaseRequest,
            url: `/api/casap-ocr-cases/submit/${params.caseId}`,
            headers: {
                Authorization: `Bearer ${cookies.get('access_token')}`,
            },
        })
            .then((response) => {
                console.log(response);
                message.success("Submit Case SUCCESSFULLY");
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                setLoading(false);
                message.error("Submit Case FAILED");
                console.log(error.config);
            });
    }

    const handleResubmit = async () => {

        const values = form.getFieldsValue();
        console.log("Form Values", values);

        let payload = {
            ...values,
            validation: extractedData?.validation ?? "",
            property: {
                ...values.property,
                memo_date: values.property?.memo_date
                    ? values.property.memo_date.format("DD-MM-YYYY")
                    : null
            },
            count_Vendors: values.vendors.length,
            count_Purchasers: values.purchasers.length,
        };
        payload["Agent Branch"] = payload?.selling_agent?.person_branch ?? "";

        let validateCaseRequest = {};
        validateCaseRequest.ValidatedData = JSON.stringify(payload);

        await axiosConfig({
            method: 'post',
            data: validateCaseRequest,
            url: `/api/casap-ocr-cases/resubmit/${params.caseId}`,
            headers: {
                Authorization: `Bearer ${cookies.get('access_token')}`,
            },
        })
            .then((response) => {
                console.log(response);
                message.success("Resubmit Case SUCCESSFULLY");
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                setLoading(false);
                message.error("Resubmit Case FAILED");
                console.log(error.config);
            });
    }

    const handleReject = async (reason) => {

        let rejectRequest = {};
        rejectRequest.reason = reason;

        await axiosConfig({
            method: 'post',
            url: `/api/casap-ocr-cases/reject/${params.caseId}`,
            data: rejectRequest,
            headers: {
                Authorization: `Bearer ${cookies.get('access_token')}`,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                console.log(response);
                message.success("Reject Case SUCCESSFULLY");
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                setLoading(false);
                message.error("Reject Case FAILED");
                console.log(error.config);
            });
    }

    const convertDatesToMoment = (obj, dateFields, format = "DD-MM-YYYY") => {
        if (!obj) return obj;

        if (Array.isArray(obj)) {
            return obj.map(item => convertDatesToMoment(item, dateFields, format));
        }

        if (typeof obj === "object") {
            return Object.keys(obj).reduce((acc, key) => {
                const value = obj[key];

                if (dateFields.includes(key) && typeof value === "string") {
                    acc[key] = moment(value, format);
                } else {
                    acc[key] = convertDatesToMoment(value, dateFields, format);
                }
                return acc;
            }, {});
        }

        return obj;
    };

    const fetchCaseDetails = async () => {
        await axiosConfig({
            method: 'get',
            url: `/api/casap-ocr-cases/get-by-id/${params.caseId}`,
            headers: {
                Authorization: `Bearer ${cookies.get('access_token')}`,
            },
        })
            .then((response) => {
                console.log(response);
                let caseData = response.data.data;
                let extractedData = caseData.extractedData;
                let validatedData = caseData.validatedData;

                setExtractedData(extractedData);
                setModeratedData(validatedData);

                console.log("Extracted Data", extractedData);
                console.log("Validated Data", validatedData);

                if (!validatedData) {
                    setInitialData(extractedData);
                    const transformed = convertDatesToMoment(JSON.parse(extractedData), ["memo_date"]);
                    form.setFieldsValue(transformed);
                }
                else {
                    setInitialData(validatedData);
                    const transformed = convertDatesToMoment(JSON.parse(validatedData), ["memo_date"]);
                    form.setFieldsValue(transformed);
                }
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                setLoading(false);
                console.log(error.config);
            });
    };

    const resetToExtracted = () => {
        const transformed = convertDatesToMoment(JSON.parse(extractedData), ["memo_date"]);
        form.setFieldsValue(transformed);
        message.success("Case data restored to first extracted version SUCCESSFULLY")
    }

    const fetchCaseDocuments = async () => {
        await axiosConfig({
            method: 'get',
            url: `/api/casap-ocr-documents/get-by-case/${params.caseId}`,
            headers: {
                Authorization: `Bearer ${cookies.get('access_token')}`,
            },
        })
            .then((response) => {
                console.log(response);
                console.log('Documents Data', response);
                let caseDocuments = response.data.data;

                let documents = [];

                for (let index = 0; index < caseDocuments.length; index++) {

                    let document = {};
                    let cd = caseDocuments[index];
                    let key = `doc${index}`;
                    document.key = key;
                    let caseBlobUrl = cd.documentBlobUrl;
                    document.url = caseBlobUrl;
                    let documentName = cd.documentName;

                    documentName = documentName.replace(/.pdf/i, "")

                    let documentClass = cd.documentClass;

                    if (documentClass) {
                        switch (documentClass) {
                            case 1:
                                documentName = "Email";
                                break;
                            case 2:
                                documentName = "MoS";
                                break;
                            case 3:
                                documentName = "EPC";
                                break;
                            case 4:
                                documentName = "Brochure";
                                break;
                            case 5:
                                documentName = "Chain Info";
                                break;
                            case 6:
                                documentName = "Identity";
                                break;
                            case 7:
                                documentName = "CoS";
                                break;
                            default:
                                break;
                        }
                    }

                    let existDocuments = documents.filter(d => d.title == documentName);
                    let existLength = existDocuments.length;

                    if (existLength > 0) {
                        documentName = documentName + (existLength + 1);
                    }
                    document.title = documentName;

                    documents.push(document);

                }

                setDocuments(documents);

            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                setLoading(false);
                console.log(error.config);
            });
    };

    const validateCase = async (validatedRequest) => {
        await axiosConfig({
            method: 'post',
            data: validatedRequest,
            url: `/api/casap-ocr-cases/validate/${params.caseId}`,
            headers: {
                Authorization: `Bearer ${cookies.get('access_token')}`,
            },
        })
            .then((response) => {
                console.log(response);

            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                setLoading(false);
                console.log(error.config);
            });
    };

    const setStatusCompleted = async (comments = "") => {
        await axiosConfig({
            method: 'post',
            data: {
                username: currentUser?.email ?? "",
                comments,
            },
            url: `/api/casap-ocr-cases/set-status-completed/${params.caseId}`,
            headers: {
                Authorization: `Bearer ${cookies.get('access_token')}`,
            },
        })
            .then((response) => {
                console.log(response);
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                setLoading(false);
                console.log(error.config);
            });
    };

    useEffect(() => {
        if (documents && documents.length > 0) {
            setActiveKey(prev => prev ?? documents[0].key);

            setLoadedKeys(prev => {
                const next = new Set(prev);
                next.add(documents[0].key);
                return next;
            });
        }
    }, [documents]);

    const handleTabChange = key => {
        setActiveKey(key);
        setLoadedKeys(prev => {
            const next = new Set(prev);
            next.add(key);
            return next;
        });
    };

    useEffect(() => {
        let isMounted = true;
        if (currentUser && currentUser.id && isMounted) {
            fetchCaseDetails();
            fetchCaseDocuments();
        }
        return () => {
            isMounted = false;
        };
    }, []);

    const onFinish = async (values) => {

        console.log('Received updated values of form: ', values);

        let payload = {
            ...values,
            validation: extractedData?.validation ?? "",
            property: {
                ...values.property,
                memo_date: values.property?.memo_date
                    ? values.property.memo_date.format("DD-MM-YYYY")
                    : null
            },
            count_Vendors: values.vendors.length,
            count_Purchasers: values.purchasers.length,
        };
        payload["Agent Branch"] = payload?.selling_agent?.person_branch ?? "";

        let validateCaseRequest = {};
        validateCaseRequest.ValidatedData = JSON.stringify(payload);

        try {

            let validateResponse = await validateCase(validateCaseRequest);
            message.success("Validate Case Data SUCCESSFULLY");

        } catch (error) {

            message.success("Validate Case Data FAILED");

        }

    };

    const onReset = () => {
        const transformed = convertDatesToMoment(JSON.parse(initialData), ["memo_date"]);
        form.setFieldsValue(transformed);
        message.success("Reset Case Data SUCCESSFULLY")
    };

    const renderAddressFields = (name, fieldKeyPrefix, restField) => (
        <>
            <Col span={12}>
                <Form.Item
                    {...restField}
                    name={[name, 'address', 0, 'address_line1']}
                    fieldKey={[fieldKeyPrefix, 'address', 0, 'address_line1']}
                    label="Address Line 1"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    {...restField}
                    name={[name, 'address', 0, 'address_line2']}
                    fieldKey={[fieldKeyPrefix, 'address', 0, 'address_line2']}
                    label="Address Line 2"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'address', 0, 'address_city']}
                    fieldKey={[fieldKeyPrefix, 'address', 0, 'address_city']}
                    label="City"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'address', 0, 'address_county']}
                    fieldKey={[fieldKeyPrefix, 'address', 0, 'address_county']}
                    label="County"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'address', 0, 'address_postcode']}
                    fieldKey={[fieldKeyPrefix, 'address', 0, 'address_postcode']}
                    label="Postcode"
                >
                    <Input />
                </Form.Item>
            </Col>
        </>
    );

    const renderPersonFields = (name, fieldKeyPrefix, restField) => (
        <>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'person_type']}
                    fieldKey={[fieldKeyPrefix, 'person_type']}
                    label="Person Type"
                >
                    <Select placeholder="Select a type">
                        <Option value="0">Individual</Option>
                        <Option value="1">Solicitor</Option>
                        <Option value="2">Estate Agent</Option>
                        <Option value="3">Company</Option>
                        <Option value="9">Mortgage Broker</Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'person_company']}
                    fieldKey={[fieldKeyPrefix, 'person_company']}
                    label="Company Name"
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const personType = getFieldValue([name, 'person_type']);
                                if (personType === '3' && !value) {
                                    return Promise.reject(new Error('Company name is required for Company type!'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input placeholder="Enter company name (if applicable)" />
                </Form.Item>
            </Col>
            <Col span={8}></Col>

            {/* Guideline-required fields: add className only, NO logic changes */}
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'person_fname']}
                    fieldKey={[fieldKeyPrefix, 'person_fname']}
                    label="First Name"
                    className="required-guideline"
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const personType = getFieldValue([name, 'person_type']);
                                if (personType === '0' && !value) {
                                    return Promise.reject(new Error('First name is required for Individual type!'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input placeholder="Enter first name (if applicable)" />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'person_lname']}
                    fieldKey={[fieldKeyPrefix, 'person_lname']}
                    label="Last Name"
                    className="required-guideline"
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const personType = getFieldValue([name, 'person_type']);
                                if (personType === '0' && !value) {
                                    return Promise.reject(new Error('Last name is required for Individual type!'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input placeholder="Enter last name (if applicable)" />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'person_email']}
                    fieldKey={[fieldKeyPrefix, 'person_email']}
                    label="Email"
                    className="required-guideline"
                >
                    <Input />
                </Form.Item>
                <Form.Item name={[name, 'entity_validation']} initialValue="1">
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item name={[name, 'person_is_company']} initialValue={false}>
                    <Input type="hidden" />
                </Form.Item>
            </Col>

            {renderAddressFields(name, fieldKeyPrefix, restField)}
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'phone_number']}
                    fieldKey={[fieldKeyPrefix, 'phone_number']}
                    label="Phone Number"
                    className="required-guideline"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item
                    {...restField}
                    name={[name, 'phone_type_description']}
                    fieldKey={[fieldKeyPrefix, 'phone_type_description']}
                    label="Phone Type"
                >
                    <Select placeholder="Select a type">
                        <Option value="Mobile">Mobile</Option>
                        <Option value="Work">Work</Option>
                        <Option value="Home">Home</Option>
                        <Option value="Other">Other</Option>
                    </Select>
                </Form.Item>
            </Col>
        </>
    );

    // ============================
    // EXTRA INFO TAB HELPERS (NEW)
    // ============================
    const safeParseJson = (jsonStr) => {
        try {
            if (!jsonStr) return null;
            return typeof jsonStr === "string" ? JSON.parse(jsonStr) : jsonStr;
        } catch (e) {
            return null;
        }
    };

    let extractedObj = safeParseJson(extractedData);
    if (moderatedData)
    {
        extractedObj = safeParseJson(moderatedData);
    }

    // Pass/Fail/Review strictly from validation/entity_validation values.
    const getPassFailFromEntityValidation = (entityValidation) => {
        const validationValue = String(entityValidation);
        const isPass = validationValue === "1";
        const isReview = validationValue === "3";

        return (
            <Tag color={isReview ? "orange" : isPass ? "green" : "red"}>
                {isReview ? "REVIEW" : isPass ? "PASS" : "FAIL"}
            </Tag>
        );
    };

    const renderRequiredGuideline = (items) => {
        return (
            <ul style={{ marginTop: 6, paddingLeft: 18 }}>
                {items.map((x, idx) => (
                    <li key={idx}>{x}</li>
                ))}
            </ul>
        );
    };

    return (

        <div className="ocr-list-page">
            <div className="ocr-title">
                <span className="text">CASE DETAILS</span>
            </div>
            <Form
                form={form}
                name="edit_property_data"
                onFinish={onFinish}
                layout="vertical"
            >

                <Row gutter={12} style={{ padding: '20px' }}>
                    <Col span={24}>
                        <Card style={{ marginBottom: 20 }} bodyStyle={{ padding: '1rem' }}>
                            <Space wrap style={{ justifyContent: "center", width: "100%" }}>
                                <Popconfirm
                                    title="Are you sure to submit?"
                                    onConfirm={handleSubmit}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button htmlType="button" className="ant-btn-submit">
                                        Submit Case
                                    </Button>
                                </Popconfirm>
                                <Button danger onClick={showModal}>Reject Case</Button>
                                <Button type="primary" htmlType="submit">
                                    Save Validation
                                </Button>
                                <Button htmlType="button" onClick={onReset}>
                                    Clear Changes
                                </Button>
                                <Button htmlType="button" onClick={resetToExtracted}>
                                    Reset to Original
                                </Button>
                                <Popconfirm
                                    title="Are you sure to resubmit?"
                                    onConfirm={handleResubmit}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button htmlType="button" className="ant-btn-resubmit">
                                        Resubmit
                                    </Button>
                                </Popconfirm>
                                <Button
                                    htmlType="button"
                                    onClick={showValidatedModal}
                                    style={{ backgroundColor: "#722ed1", borderColor: "#722ed1", color: "#fff", marginLeft: "auto" }}
                                >
                                    Validated
                                </Button>
                            </Space>
                        </Card>
                    </Col>

                    <Col span={12}>

                        <Tabs defaultActiveKey="vendors" style={{ marginBottom: 20 }}>
                            {/* Tab 1: Vendors */}
                            <TabPane tab="Vendors" key="vendors" forceRender>
                                <Card title={"Vendors"} style={{ marginBottom: 20 }}>
                                    <Form.List name="vendors">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map(({ key, name, fieldKey, ...restField }) => {
                                                    const isCollapsed = collapsedVendors[name] ?? false;
                                                    return (
                                                        <Card key={key} extra={
                                                            <Button type="text" onClick={() => {
                                                                setCollapsedVendors((prev) => ({
                                                                    ...prev,
                                                                    [name]: !prev[name],
                                                                }));
                                                            }}>
                                                                {isCollapsed ? <DownOutlined /> : <UpOutlined />}
                                                            </Button>
                                                        } title={`Vendor ${name + 1}`} style={{ flex: 1, border: '1px solid #d9d9d9', marginBottom: 16 }}>
                                                            {!isCollapsed && (
                                                                <>
                                                                    <Row gutter={12}>
                                                                        {renderPersonFields(name, fieldKey, restField)}
                                                                    </Row>
                                                                    <Button
                                                                        type="dashed"
                                                                        danger
                                                                        onClick={() => remove(name)}
                                                                        icon={<MinusCircleOutlined />}
                                                                        style={{ marginTop: 8 }}
                                                                    >
                                                                        Remove Vendor
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </Card>
                                                    )
                                                }
                                                )}
                                                <Form.Item>
                                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                        Add Vendor
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                    </Form.List>
                                </Card>
                            </TabPane>

                            <TabPane tab="Solicitor (v)" key="vendorsSolicitor" forceRender>
                                <Card title="Vendors Solicitor" style={{ marginBottom: 20 }} >
                                    <Row gutter={12}>
                                        <Col span={8}>
                                            <Form.Item name={['vendors_solicitor', 'person_type']} label="Person Type" >
                                                <Select placeholder="Select a type">
                                                    <Option value="0">Individual</Option>
                                                    <Option value="1">Solicitor</Option>
                                                    <Option value="2">Estate Agent</Option>
                                                    <Option value="3">Company</Option>
                                                    <Option value="9">Mortgage Broker</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                name={['vendors_solicitor', 'person_company']}
                                                label="Company Name"
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const personType = getFieldValue(['vendors_solicitor', 'person_type']);
                                                            if (personType === '3' && !value) {
                                                                return Promise.reject(new Error('Company name is required for Company type!'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input placeholder="Enter company name (if applicable)" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}></Col>

                                        <Col span={8}>
                                            <Form.Item
                                                name={['vendors_solicitor', 'person_fname']}
                                                label="First Name"
                                                className="required-guideline"
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const personType = getFieldValue(['vendors_solicitor', 'person_type']);
                                                            if (personType === '0' && !value) {
                                                                return Promise.reject(new Error('First name is required for Individual type!'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input placeholder="Enter first name (if applicable)" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                name={['vendors_solicitor', 'person_lname']}
                                                label="Last Name"
                                                className="required-guideline"
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const personType = getFieldValue(['vendors_solicitor', 'person_type']);
                                                            if (personType === '0' && !value) {
                                                                return Promise.reject(new Error('Last name is required for Individual type!'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input placeholder="Enter last name (if applicable)" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item name={['vendors_solicitor', 'person_email']} label="Email" className="required-guideline">
                                                <Input />
                                            </Form.Item>
                                        </Col>

                                        {renderAddressFields('vendors_solicitor', 'vendors_solicitor')}
                                        <Col span={8}>
                                            <Form.Item name={['vendors_solicitor', 'phone_number']} label="Phone Number" className="required-guideline">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                name={['vendors_solicitor', 'phone_type_description']}
                                                label="Phone Type"
                                            >
                                                <Select placeholder="Select a type">
                                                    <Option value="Mobile">Mobile</Option>
                                                    <Option value="Work">Work</Option>
                                                    <Option value="Home">Home</Option>
                                                    <Option value="Other">Other</Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item name={['vendors_solicitor', 'entity_validation']} initialValue="1">
                                                <Input type="hidden" />
                                            </Form.Item>
                                            <Form.Item name={['vendors_solicitor', 'person_is_company']} initialValue={false}>
                                                <Input type="hidden" />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                </Card>
                            </TabPane>

                            <TabPane tab="Purchasers" key="purchasers" forceRender>
                                <Card title="Purchasers" style={{ marginBottom: 20 }}>
                                    <Form.List name="purchasers">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map(({ key, name, fieldKey, ...restField }) => {
                                                    const isCollapsed = purchasersCollapsed[name] ?? false;
                                                    return (
                                                        <Card key={key} title={`Purchaser ${name + 1}`} extra={
                                                            <Button type="text" onClick={() => {
                                                                setPurchasersCollapsed((prev) => ({
                                                                    ...prev,
                                                                    [name]: !prev[name],
                                                                }));
                                                            }}>
                                                                {isCollapsed ? <DownOutlined /> : <UpOutlined />}
                                                            </Button>
                                                        } style={{ flex: 1, border: '1px solid #d9d9d9', marginBottom: 16 }}>
                                                            {!isCollapsed && (<>
                                                                <Row gutter={12}>
                                                                    {renderPersonFields(name, fieldKey, restField)}
                                                                </Row>
                                                                <Button type="dashed" danger onClick={() => remove(name)} icon={<MinusCircleOutlined />} style={{ marginTop: 8 }}>
                                                                    Remove Purchaser
                                                                </Button>
                                                            </>
                                                            )}

                                                        </Card>
                                                    )
                                                })}
                                                <Form.Item>
                                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                        Add Purchaser
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                    </Form.List>
                                </Card>
                            </TabPane>

                            <TabPane tab="Solicitor (p)" key="purchasersSolicitor" forceRender>
                                <Card title="Purchasers Solicitor" style={{ marginBottom: 20 }}>
                                    <Row gutter={12}>
                                        <Col span={8}>
                                            <Form.Item name={['purchasers_solicitor', 'person_type']} label="Person Type" >
                                                <Select placeholder="Select a type">
                                                    <Option value="0">Individual</Option>
                                                    <Option value="1">Solicitor</Option>
                                                    <Option value="2">Estate Agent</Option>
                                                    <Option value="3">Company</Option>
                                                    <Option value="9">Mortgage Broker</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                name={['purchasers_solicitor', 'person_company']}
                                                label="Company Name"
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const personType = getFieldValue(['purchasers_solicitor', 'person_type']);
                                                            if (personType === '3' && !value) {
                                                                return Promise.reject(new Error('Company name is required for Company type!'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input placeholder="Enter company name (if applicable)" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}></Col>

                                        <Col span={8}>
                                            <Form.Item
                                                name={['purchasers_solicitor', 'person_fname']}
                                                label="First Name"
                                                className="required-guideline"
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const personType = getFieldValue(['purchasers_solicitor', 'person_type']);
                                                            if (personType === '0' && !value) {
                                                                return Promise.reject(new Error('First name is required for Individual type!'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input placeholder="Enter first name (if applicable)" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                name={['purchasers_solicitor', 'person_lname']}
                                                label="Last Name"
                                                className="required-guideline"
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const personType = getFieldValue(['purchasers_solicitor', 'person_type']);
                                                            if (personType === '0' && !value) {
                                                                return Promise.reject(new Error('Last name is required for Individual type!'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input placeholder="Enter last name (if applicable)" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item name={['purchasers_solicitor', 'person_email']} label="Email" className="required-guideline">
                                                <Input />
                                            </Form.Item>
                                        </Col>

                                        {renderAddressFields('purchasers_solicitor', 'purchasers_solicitor')}
                                        <Col span={8}>
                                            <Form.Item name={['purchasers_solicitor', 'phone_number']} label="Phone Number" className="required-guideline">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                name={['purchasers_solicitor', 'phone_type_description']}
                                                label="Phone Type"
                                            >
                                                <Select placeholder="Select a type">
                                                    <Option value="Mobile">Mobile</Option>
                                                    <Option value="Work">Work</Option>
                                                    <Option value="Home">Home</Option>
                                                    <Option value="Other">Other</Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item name={['purchasers_solicitor', 'entity_validation']} initialValue="1">
                                                <Input type="hidden" />
                                            </Form.Item>
                                            <Form.Item name={['purchasers_solicitor', 'person_is_company']} initialValue={false}>
                                                <Input type="hidden" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </TabPane>

                            <TabPane tab="Agent" key="sellingAgent" forceRender>
                                <Card title="Selling Agent" style={{ marginBottom: 20 }} extra={
                                    <Button type="text" onClick={() => setSellingAgentCollapsed(!sellingAgentCollapsed)}>
                                        {sellingAgentCollapsed ? <DownOutlined /> : <UpOutlined />}
                                    </Button>}>
                                    {
                                        !sellingAgentCollapsed && (<Row gutter={12}>
                                            <Col span={8}>
                                                <Form.Item name={['selling_agent', 'person_type']} label="Person Type">
                                                    <Select placeholder="Select a type">
                                                        <Option value="0">Individual</Option>
                                                        <Option value="1">Solicitor</Option>
                                                        <Option value="2">Estate Agent</Option>
                                                        <Option value="3">Company</Option>
                                                        <Option value="9">Mortgage Broker</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    name={['selling_agent', 'person_company']}
                                                    label="Company Name"
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const personType = getFieldValue(['selling_agent', 'person_type']);
                                                                if (personType === '3' && !value) {
                                                                    return Promise.reject(new Error('Company name is required for Company type!'));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input placeholder="Enter company name (if applicable)" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    name={['selling_agent', 'person_branch']}
                                                    label="Branch"
                                                    className="required-guideline"
                                                >
                                                    <Input placeholder="Enter branch name" />
                                                </Form.Item>
                                            </Col>

                                            <Col span={8}>
                                                <Form.Item
                                                    name={['selling_agent', 'person_fname']}
                                                    label="First Name"
                                                    className="required-guideline"
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const personType = getFieldValue(['selling_agent', 'person_type']);
                                                                if (personType === '0' && !value) {
                                                                    return Promise.reject(new Error('First name is required for Individual type!'));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input placeholder="Enter first name (if applicable)" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    name={['selling_agent', 'person_lname']}
                                                    label="Last Name"
                                                    className="required-guideline"
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const personType = getFieldValue(['selling_agent', 'person_type']);
                                                                if (personType === '0' && !value) {
                                                                    return Promise.reject(new Error('Last name is required for Individual type!'));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input placeholder="Enter last name (if applicable)" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item name={['selling_agent', 'person_email']} label="Email" className="required-guideline">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            {renderAddressFields('selling_agent', 'selling_agent')}
                                            <Col span={8}>
                                                <Form.Item name={['selling_agent', 'phone_number']} label="Phone Number" className="required-guideline">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    name={['selling_agent', 'phone_type_description']}
                                                    label="Phone Type"
                                                >
                                                    <Select placeholder="Select a type">
                                                        <Option value="Mobile">Mobile</Option>
                                                        <Option value="Work">Work</Option>
                                                        <Option value="Home">Home</Option>
                                                        <Option value="Other">Other</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Form.Item name={['selling_agent', 'entity_validation']} initialValue="1">
                                                <Input type="hidden" />
                                            </Form.Item>
                                            <Form.Item name={['selling_agent', 'person_is_company']} initialValue={false}>
                                                <Input type="hidden" />
                                            </Form.Item>
                                        </Row>)
                                    }
                                </Card>
                            </TabPane>

                            <TabPane tab="Broker" key="mortgageBroker" forceRender>

                                <Card title="Mortgage Broker" style={{ marginBottom: 20 }} extra={
                                    <Button type="text" onClick={() => setMortgageBrokerCollapsed(!mortgageBrokerCollapsed)}>
                                        {mortgageBrokerCollapsed ? <DownOutlined /> : <UpOutlined />}
                                    </Button>}>
                                    {
                                        !mortgageBrokerCollapsed && (
                                            <Row gutter={12}>
                                                <Col span={8}>
                                                    <Form.Item name={['mortgage_broker', 'person_type']} label="Person Type" >
                                                        <Select placeholder="Select a type">
                                                            <Option value="0">Individual</Option>
                                                            <Option value="1">Solicitor</Option>
                                                            <Option value="2">Estate Agent</Option>
                                                            <Option value="3">Company</Option>
                                                            <Option value="9">Mortgage Broker</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name={['mortgage_broker', 'person_company']}
                                                        label="Company Name"
                                                        rules={[
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    const personType = getFieldValue(['mortgage_broker', 'person_type']);
                                                                    if (personType === '3' && !value) {
                                                                        return Promise.reject(new Error('Company name is required for Company type!'));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            }),
                                                        ]}
                                                    >
                                                        <Input placeholder="Enter company name (if applicable)" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}></Col>

                                                <Col span={8}>
                                                    <Form.Item
                                                        name={['mortgage_broker', 'person_fname']}
                                                        label="First Name"
                                                        className="required-guideline"
                                                        rules={[
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    const personType = getFieldValue(['mortgage_broker', 'person_type']);
                                                                    if (personType === '0' && !value) {
                                                                        return Promise.reject(new Error('First name is required for Individual type!'));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            }),
                                                        ]}
                                                    >
                                                        <Input placeholder="Enter first name (if applicable)" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name={['mortgage_broker', 'person_lname']}
                                                        label="Last Name"
                                                        className="required-guideline"
                                                        rules={[
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    const personType = getFieldValue(['mortgage_broker', 'person_type']);
                                                                    if (personType === '0' && !value) {
                                                                        return Promise.reject(new Error('Last name is required for Individual type!'));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            }),
                                                        ]}
                                                    >
                                                        <Input placeholder="Enter last name (if applicable)" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item name={['mortgage_broker', 'person_email']} label="Email" className="required-guideline">
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                {renderAddressFields('mortgage_broker', 'mortgage_broker')}
                                                <Col span={8}>
                                                    <Form.Item name={['mortgage_broker', 'phone_number']} label="Phone Number" className="required-guideline">
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name={['mortgage_broker', 'phone_type_description']}
                                                        label="Phone Type"
                                                    >
                                                        <Select placeholder="Select a type">
                                                            <Option value="Mobile">Mobile</Option>
                                                            <Option value="Work">Work</Option>
                                                            <Option value="Home">Home</Option>
                                                            <Option value="Other">Other</Option>
                                                        </Select>
                                                    </Form.Item>
                                                    <Form.Item name={['mortgage_broker', 'entity_validation']} initialValue="1">
                                                        <Input type="hidden" />
                                                    </Form.Item>
                                                    <Form.Item name={['mortgage_broker', 'person_is_company']} initialValue={false}>
                                                        <Input type="hidden" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                </Card>

                            </TabPane>

                            <TabPane tab="Property" key="propertyDetails" forceRender>
                                <Card title="Property Details" style={{ marginBottom: 20 }} extra={
                                    <Button type="text" onClick={() => setPropertyDetailsCollapsed(!propertyDetailsCollapsed)}>
                                        {propertyDetailsCollapsed ? <DownOutlined /> : <UpOutlined />}
                                    </Button>}>
                                    {
                                        !propertyDetailsCollapsed && (<Row gutter={12}>
                                            <Col span={24}>
                                                <Form.Item name={['property', 'full_property_address_single_line']} label="Full Property Address (Single Line)">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            {renderAddressFields('property', 'property')}

                                            <Col span={8}>
                                                <Form.Item name={['property', 'tenure']} label="Tenure" className="required-guideline">
                                                    <Select placeholder="Select Tenure">
                                                        <Option value="Freehold">Freehold</Option>
                                                        <Option value="Leasehold">Leasehold</Option>
                                                        <Option value="Unknown">Unknown</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item name={['property', 'sale_price']} label="Sale Price" className="required-guideline">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    name={["property", "memo_date"]}
                                                    label="Memo Date"
                                                    className="required-guideline"
                                                >
                                                    <DatePicker
                                                        format="DD-MM-YYYY"
                                                        style={{ width: "100%" }}
                                                        placeholder="Select date"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item name={['property', 'special_remarks']} label="Special Remarks">
                                                    <Input.TextArea rows={2} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item name={['property', 'inclusions_or_exclusions']} label="Inclusions or Exclusions">
                                                    <Input.TextArea rows={2} />
                                                </Form.Item>
                                                <Form.Item name={['property', 'entity_validation']} initialValue="1">
                                                    <Input type="hidden" />
                                                </Form.Item>
                                            </Col>
                                        </Row>)
                                    }
                                </Card>
                            </TabPane>

                            <TabPane tab="Chain Info" key="chainInformation" forceRender>
                                <Card title="Chain Information" style={{ marginBottom: 20 }} extra={
                                    <Button type="text" onClick={() => setChainInformationCollapsed(!chainInformationCollapsed)}>
                                        {chainInformationCollapsed ? <DownOutlined /> : <UpOutlined />}
                                    </Button>}>
                                    {
                                        !chainInformationCollapsed && (
                                            <Row gutter={12}>
                                                <Col span={12}>
                                                    <Form.Item name={['chain_information', 'buyers_position']} label="Buyers Position">
                                                        <Input.TextArea rows={3} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name={['chain_information', 'sellers_position']} label="Sellers Position">
                                                        <Input.TextArea rows={3} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item name={['chain_information', 'important_information']} label="Important Information">
                                                        <Input.TextArea rows={3} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name={['chain_information', 'chain_summary']} label="Chain Summary">
                                                        <Input.TextArea rows={3} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name={['chain_information', 'chain_view']} label="Chain View">
                                                        <Input.TextArea rows={3} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name={['chain_information', 'chain_count']} label="Chain Count">
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name={['chain_information', 'chain_info']} label="Chain Info" valuePropName="checked" className="required-guideline">
                                                        <Switch />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12} style={{ display: "none" }}>
                                                    <Form.Item name={['chain_information', 'entity_validation']} initialValue="1">
                                                        <Input type="hidden" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )
                                    }

                                </Card>
                            </TabPane>

                            {/* ✅ NEW TAB: EXTRA INFO */}
                            <TabPane tab="Extra Info" key="extraInfo" forceRender>
                                <Card title="Extra Info (Pass / Fail / Review)">
                                    {!extractedObj ? (
                                        <div style={{ padding: 12, color: "#888" }}>
                                            No extracted data available.
                                        </div>
                                    ) : (
                                        <div>

                                            {/* 1. Validation */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Validation</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.validation)}
                                                </div>
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div>

                                            {/* 2. Vendor */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Vendor</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.vendors?.[0]?.entity_validation)}
                                                </div>
                                                {/* <div style={{ marginTop: 8 }}>
                                                    Required fields guideline:
                                                    {renderRequiredGuideline(["First Name", "Last Name", "Phone", "Email"])}
                                                </div> */}
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div>

                                            {/* 3. Vendors Solicitor */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Vendors Solicitor</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.vendors_solicitor?.entity_validation)}
                                                </div>
                                                {/* <div style={{ marginTop: 8 }}>
                                                    Required fields guideline:
                                                    {renderRequiredGuideline(["First Name", "Last Name", "Phone", "Email"])}
                                                </div> */}
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div>

                                            {/* 4. Purchaser */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Purchaser</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.purchasers?.[0]?.entity_validation)}
                                                </div>
                                                {/* <div style={{ marginTop: 8 }}>
                                                    Required fields guideline:
                                                    {renderRequiredGuideline(["First Name", "Last Name", "Phone", "Email"])}
                                                </div> */}
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div>

                                            {/* 5. Purchasers Solicitor */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Purchasers Solicitor</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.purchasers_solicitor?.entity_validation)}
                                                </div>
                                                {/* <div style={{ marginTop: 8 }}>
                                                    Required fields guideline:
                                                    {renderRequiredGuideline(["First Name", "Last Name", "Phone", "Email"])}
                                                </div> */}
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div>

                                            {/* 6. Selling Agent */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Selling Agent</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.selling_agent?.entity_validation)}
                                                </div>
                                                {/* <div style={{ marginTop: 8 }}>
                                                    Required fields guideline:
                                                    {renderRequiredGuideline(["Branch Name", "First Name", "Last Name", "Phone", "Email"])}
                                                </div> */}
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div>

                                            {/* 7. Broker */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Broker</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.mortgage_broker?.entity_validation)}
                                                </div>
                                                {/* <div style={{ marginTop: 8 }}>
                                                    Required fields guideline:
                                                    {renderRequiredGuideline(["First Name", "Last Name", "Phone", "Email"])}
                                                </div> */}
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div>

                                            {/* 8. Property */}
                                            <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>Property</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.property?.entity_validation)}
                                                </div>
                                                {/* <div style={{ marginTop: 8 }}>
                                                    Required fields guideline:
                                                    {renderRequiredGuideline(["Price", "Memo Date", "Tenure"])}
                                                </div> */}
                                                {/* <Divider style={{ margin: "10px 0" }} /> */}
                                            </div>

                                            {/* 9. Chain Info */}
                                            {/* <div style={{ marginBottom: 14 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <strong>9. Chain Info</strong>
                                                    {getPassFailFromEntityValidation(extractedObj?.chain_information?.entity_validation)}
                                                </div>
                                                <Divider style={{ margin: "10px 0" }} />
                                            </div> */}

                                        </div>
                                    )}
                                </Card>
                            </TabPane>

                        </Tabs>

                    </Col>


                    {/* Part 2: Document Viewer - now with Tabs */}
                    <Col span={12}>
                        <Card bodyStyle={{ padding: 0 }}>
                            {documents && documents.length > 0 ? (
                                <Tabs
                                    activeKey={activeKey}
                                    onChange={handleTabChange}
                                    style={{ marginLeft: "10px", height: "100%" }}
                                >
                                    {documents.map(doc => (
                                        <TabPane tab={doc.title} key={doc.key}>
                                            {loadedKeys.has(doc.key) ? (
                                                <iframe
                                                    src={doc.url}
                                                    style={{
                                                        width: "100%",
                                                        height: "calc(100vh - 170px)",
                                                        border: "none",
                                                    }}
                                                    title={doc.title}
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        padding: 20,
                                                        textAlign: "center",
                                                        color: "#888",
                                                    }}
                                                >
                                                    Loading...
                                                </div>
                                            )}
                                        </TabPane>
                                    ))}
                                </Tabs>
                            ) : (
                                <div style={{ textAlign: "center", padding: "20px" }}>
                                    <p>No documents to display.</p>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>
                <Modal
                    title="Reject Reason"
                    visible={visible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    okText="Submit"
                    cancelText="Cancel"
                >
                    <Form form={rejectForm} layout="vertical" name="rejectForm">
                        <Form.Item
                            name="reason"
                            label="Please enter a reason for rejection"
                            rules={[{ required: true, message: "Reason is required" }]}
                        >
                            <Input.TextArea rows={4} placeholder="Type your reason..." />
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    title="Validated"
                    visible={validatedVisible}
                    onOk={handleValidatedSubmit}
                    onCancel={handleValidatedCancel}
                    okText="Submit"
                    cancelText="Cancel"
                >
                    <Form form={validatedForm} layout="vertical" name="validatedForm">
                        <Form.Item
                            name="comments"
                            label="Comments"
                            rules={[{ required: true, message: "Comments are required" }]}
                        >
                            <Input.TextArea rows={4} placeholder="Add comments..." />
                        </Form.Item>
                    </Form>
                </Modal>
            </Form>

        </div >


    );
};

export default EditPropertyData;
